module.exports = __webpack_public_path__ + "static/img/a.ac1cb3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/a.png
// module id = iO43
// module chunks = 1